//dev
var BASE_URL = "https://nileur.5stardesigners.net/dev/nileur_api/public/api";

//qa
// var BASE_URL = "https://nileur.5stardesigners.net/qa/nileur_api/public/api";
// const configVariables = {
//   BASE_URL,
// };

const constantVariables = {
  TempUser: {
    name: "David Smith",
    email: "david@yopmail.com",
    pass: "asd123",
    userId: 12,
  },
};

export const categories = [
  {
    label: "Promotion",
    value: "Promotion",
  },
  {
    label: "Nileur",
    value: "Nileur",
  },
  {
    label: "Divine Music",
    value: "Divine-Music",
  },
  {
    label: "Break & Groove",
    value: "Break-and-Groove",
  },
  {
    label: "Stratting",
    value: "Stratting",
  },
  {
    label: "Symphonic EL",
    value: "Symphonic-EL",
  },
  {
    label: "Aether Rhythm",
    value: "Earthy-Rhythm",
  },
  {
    label: "Theeacting",
    value: "Theeacting",
  },
  {
    label: "Sokah Poetry",
    value: "Sokahpoetry",
  },
  {
    label: "Pre Recorded Events",
    value: "Pre-Recorded-Events",
  },
];

export const AGORA_CONFIG = {
  appId: process.env.REACT_APP_AGORA_APP_ID,
  role: "audience",
  latency: 1,
};
export default {
  // ...configVariables,
  ...constantVariables,
};
